import React,{ Component } from 'react'
import { Carousel, WingBlank } from 'antd-mobile';
import './banner.scss';
import {Http, urls} from '../../api/index';
class Banner extends Component {
    constructor() {
        super();
        this.state = {
            imgList: []
        };
    }

    componentDidMount() {
        this.getAdList();
    }

    getAdList() {
        let url = urls.findAdInfoList;
        Http.post({url, data: {
            adCode: 10002
        }}).then(res => {
            this.setState({
                imgList: res.data
            });
        });
    }

    render() {
        let {imgList} = this.state;
        if (imgList.length === 0) {
            return null;
        };
        return (
            <WingBlank>
            <Carousel
              autoplay={true}
              infinite
              style={{margin: '10px 0'}}
            >
              {imgList.map(val => (
                <a
                  key={val}
                  href={val.infoUrl}
                  style={{ display: 'inline-block', width: '100%'}}
                >
                  <img
                    src={val.pictureUrl}
                    alt=""
                    style={{ width: '100%', verticalAlign: 'top' }}
                    onLoad={() => {
                      // fire window resize event to change height
                      window.dispatchEvent(new Event('resize'));
                      this.setState({ imgHeight: 'auto' });
                    }}
                  />
                </a>
              ))}
            </Carousel>
          </WingBlank>
        );
    }
}
export default Banner;